/**
 * @author    Nikko Renolds
 * @package		Trap Tycoon
 * @link		  https://github.com/Ni1kko/Trap-Tycoon
 * @copyright (c) Fallox Developments2026.
 * @license		MIT
 * @description Utility for logging messages from the frontend to the backend server.
 */

import { callBackend } from "./api";

/**
 * Mirror of the backend log function.
 * Sends the log to the server for unified formatting and console output.
 */
export const log = async (tag, message) => {
  const now = new Date();
  const time = now.toTimeString().split(" ")[0];
  const day = now.getDate();
  const month = now.toLocaleString("en-US", { month: "short" });
  const suffix = ["th", "st", "nd", "rd"][
    day % 10 > 3 || Math.floor((day % 100) / 10) === 1 ? 0 : day % 10
  ];
  const timestamp = `${time} on ${day}${suffix} of ${month}`;

  console.log(`[FRONTEND:${tag.toUpperCase()} @ ${timestamp}] ${message}`);

  try {
    await callBackend("/system/log", {
      method: "POST",
      body: { tag, message },
    });
  } catch (err) {
    console.error("Failed to send log to server:", err);
  }
};
